import { CLINICAL_BASE_PATH } from '../constants';

export const BASE_CNV_CANDIDATES_PATH = `${CLINICAL_BASE_PATH}/cnv_candidates`;
export const CNV_CANDIDATES_CREATE_PATH = `${BASE_CNV_CANDIDATES_PATH}/create`;
